/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import AutoComplete from "../../../../components/hookForms/autoComplete";
import CloseIcon from "@mui/icons-material/Close";
import IGenericMotivoResult from "../../../../interfaces/IGenericMotivoResult";
import IGenericResult from "../../../../interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import InputMask from "../../../../components/hookForms/inputMask";
import InputNumber from "../../../../components/hookForms/inputNumber";
import InputText from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceConcessionaria from "../../../../services/serviceConcessionaria";
import serviceMotivoMovimentacaoInstalacao from "../../../../services/serviceMotivoMovimentacaoInstalacao";
import serviceRebalanceMovimentacaoInstalacao from "../../../../services/serviceRebalanceMovimentacaoInstalacao";
import serviceUsina from "../../../../services/serviceUsina";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data: {
        open: boolean;
        id: string;
        cicloFaturamento: string;
        nomeConcessionaria: string;
        tipoDocumentoCliente: string;
        numeroDocumentoCliente: string;
        nomeCliente: string;
        numeroInstalacao: string;
        cotaAtual: string;
        cotaAlterada: string;
        motivo: string;
        status: string;
        observacao: string;
        concessionariaID: string;
        rebalanceMotivoMovimentacaoInstalacaoID: string;
        rebalanceCicloMovimentacaoInstalacaoID: string;
        rebalanceMovimentacaoInstalacaoID: string;
        usinaID: string;
        tipoCiclo: string;
        dataHoraUltimaAtualizacao: string;
    };
}

export default function DialogEdit({ open, onClose, data, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [motivoDataOptions, setMotivoDataOptions] = useState<IGenericMotivoResult[]>([]);
    const [typeDocument, setTypeDocument] = useState("");

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            cicloFaturamento: "",
            nomeConcessionaria: "",
            tipoDocumentoCliente: "",
            numeroDocumentoCliente: "",
            nomeCliente: "",
            numeroInstalacao: "",
            cotaAtual: "",
            cotaAlterada: "",
            usinaID: "",
            motivo: "",
            status: "",
            observacao: "",
            concessionariaID: "",
        },
    });

    const tipoDocumentoOptions = [
        { label: "CPF", value: "CPF" },
        { label: "CNPJ", value: "CNPJ" },
    ];

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    useEffect(() => {
        if (data.tipoDocumentoCliente === "CNPJ") {
            setTypeDocument("99.999.999/9999-99");
        }

        if (data.tipoDocumentoCliente === "CPF") {
            setTypeDocument("999.999.999-99");
        }
    }, [data]);

    useEffect(() => {
        setMotivoData();
    }, []);

    const setMotivoData = async () => {
        serviceMotivoMovimentacaoInstalacao
            .getMotivos()
            .then((result) => {
                setMotivoDataOptions(result?.data);
            })
            .catch(() => {
                setMotivoDataOptions([]);
            });
    };

    useEffect(() => {
        setUsinaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    function handleChange(e: any) {
        if (e === "CNPJ") {
            setTypeDocument("99.999.999/9999-99");
        }

        if (e === "CPF") {
            setTypeDocument("999.999.999-99");
        }
    }

    const onSubmit = (values: any) => {
        setDisable(true);

        const treatedValues = {
            ...values,
            ativo: "S",
            numeroDocumentoCliente: values.numeroDocumentoCliente
                ? values.numeroDocumentoCliente
                      .replaceAll(".", "")
                      .replaceAll(",", "")
                      .replaceAll("-", "")
                      .replaceAll("/", "")
                      .replaceAll("_", "")
                : "",
            tipoCiclo:
                values.tipoCiclo === "Comercial"
                    ? "C"
                    : values.tipoCiclo === "Financeiro"
                    ? "F"
                    : values.tipoCiclo === "Pós venda"
                    ? "P"
                    : values.tipoCiclo === "Manual (Pré-Faturamento)"
                    ? "M"
                    : "",
            tipoDocumentoCliente:
                values.tipoDocumentoCliente === "CPF" ? "F" : values.tipoDocumentoCliente === "CNPJ" ? "J" : "",
            status: values.status === "Aberto" ? "A" : values.status === "Processado" ? "P" : "E",
            usinaID: values.usinaID ? Number(values.usinaID) : null,
        };

        serviceRebalanceMovimentacaoInstalacao
            .update(treatedValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                    reset();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Editar movimentação
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form>
                    <DialogContent dividers>
                        <Box>
                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <InputMask
                                        name="cicloFaturamento"
                                        label="Ciclo"
                                        mask="99/9999"
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <AutoComplete
                                        name="concessionariaID"
                                        label="Concessionária"
                                        control={control}
                                        error={errors}
                                        options={concessionariaDataOptions}
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <AutoComplete
                                        name="tipoDocumentoCliente"
                                        label="Tipo de documento"
                                        onChange={(e) => handleChange(e)}
                                        control={control}
                                        error={errors}
                                        options={tipoDocumentoOptions}
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <InputMask
                                        name="numeroDocumentoCliente"
                                        label="Documento"
                                        mask={typeDocument}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <AutoComplete
                                        name="usinaID"
                                        label="Usina"
                                        options={usinaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <InputNumber
                                        name="numeroInstalacao"
                                        label="Instalação"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={15}
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <InputText
                                        name="nomeCliente"
                                        label="Nome cliente"
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <InputNumber
                                        name="cotaAtual"
                                        label="Cota atual"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={10}
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <InputNumber
                                        name="cotaAlterada"
                                        label="Cota alterada"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={10}
                                    />
                                </Grid>

                                <Grid item md={12}>
                                    <AutoComplete
                                        name="rebalanceMotivoMovimentacaoInstalacaoID"
                                        label="Motivo"
                                        control={control}
                                        error={errors}
                                        options={motivoDataOptions}
                                    />
                                </Grid>

                                <Grid item md={12}>
                                    <InputText name="observacao" label="Observação" control={control} error={errors} />
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={onClose}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="button"
                            onClick={handleSubmit(onSubmit)}
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
